import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useParams, Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import CollectionAuthorModal from './CollectionAuthorModal.jsx';


const CollectionAuthorCard = ({ slug, photo, small_photo, first_name, last_name, about, offer_count,
                                in_collection_count, rating_place, url, onClick }) => {
  let { lang } = useParams();
  let [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  return(
    <Card className={'cabinet-author-card'}>
      <div className={'d-flex flex-row'}>
        <img src={ small_photo } className="d-flex flex-column p-2" onClick={ () => onClick(slug) } title={ gettext('Перейти к списку аранжировок добавленных в вашу коллекцию') } />
        <div className="d-flex flex-column p-2">
          <div className={'h5 cabinet-pseudo-link'} onClick={ handleShow } title={ gettext('Подробнее об авторе') }>{ last_name } { first_name }</div>
          <div className={'my-2'}>{ gettext('Аранжировок') }: <a href={ url } title={ gettext('Посмотреть все аранжировки автора') } className={'cabinet-link'}>{ offer_count }</a>,{' '}
            { gettext('у вас') }: <Link to={`${slug}/`} title={ gettext('Перейти к списку аранжировок добавленных в вашу коллекцию') } className={'cabinet-link'}>{ in_collection_count }</Link></div>
          <div>№{ rating_place } <a href={`/${lang}/rating/`} title={ gettext('Посмотреть рейтинг авторов') } className={'cabinet-link'}>{ gettext('в рейтинге авторов') }</a></div>
        </div>
      </div>
      <CollectionAuthorModal name={ name } about={ about } photo={ photo } show={ showModal } handleClose={ handleClose }/>
    </Card>

  )
}

CollectionAuthorCard.propTypes = {
  slug: PropTypes.string.isRequired,
  photo: PropTypes.string.isRequired,
  small_photo: PropTypes.string.isRequired,
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string.isRequired,
  about: PropTypes.string.isRequired,
  offer_count: PropTypes.number.isRequired,
  in_collection_count: PropTypes.number.isRequired,
  rating_place: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default CollectionAuthorCard;